export const GET_PROGRAM_DETAILS = '/mentorship/last';
export const GET_SERVICES_OFFERED = '/manage/mentorship/services';
export const APPLY_FOR_MENTORSHIP_PATH = '/mentorship/apply';
export const GET_PREFILL_DATA = '/mentorship/get-status/{}';
export const GET_USER_PROFILE = '/profiles/{}?fields=can_email,external_database_id,formatted_name,active,email_addresses,email_addresses__status,email_addresses__is_primary,address,slug,id,role,profile_url,location,nick_name,maiden_name,present_picture,educations__class_year,listed,is_registered,phone_numbers__number,phone_numbers__type';
export const GET_VERIFICATION_STATUS = '/mentorship/<id>/verify';
export const GET_ONBOARDING_STATUS = '/mentorship/get-status';
export const GET_PROFILE_INFORMATION_FORM = '/mentorship/profile-information-form';

export const GET_CONNECTIONS = '/mentorship/connection';
export const GET_SINGLE_CONNECTION = '/mentorship/connection?id={id}';
export const GET_MENTORS_DATA = '/mentorship/mentor';
export const GET_SINGLE_MENTOR_DATA = '/mentorship/mentor/{}';
export const GET_CONNECTION_REPORT = '/mentorship/connection/report';
export const SEND_CONNECTION_REQUEST = '/mentorship/connection';
export const UPDATE_CONNECTION_STATUS = '/mentorship/connection/{id}/status';
export const GET_FORM_ENTRY = '/custom_forms/{form_id}/entries/{entry_id}';
export const GET_MENTOR_FILTERS = '/mentorship/mentor-filters';

export const MESSAGES_PATH = '/mentorship/connection/{connection_id}/messages?page={page}';
export const POST_MESSAGES_PATH = '/mentorship/connection/{connection_id}/messages';
export const USER_FEEDBACK_API_PATH = '/user_feedback/submit';

export const FORM_FIELDS_PATH = 'custom_forms/<form_id>/fields/';
